import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Switch,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useState } from 'react';

import { useUsageAnalyticsExport } from './useUsageAnalyticsExport';

const iso = (d: Date): string => d.toISOString().slice(0, 10);
const daysAgo = (n: number): Date => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d;
};

interface UsageAnalyticsModalProps {
  clientName: string;
  isOpen: boolean;
  onClose: () => void;
}

export function UsageAnalyticsModal({
  clientName,
  isOpen,
  onClose,
}: UsageAnalyticsModalProps) {
  const [from, setFrom] = useState(iso(daysAgo(30)));
  const [to, setTo] = useState(iso(new Date()));
  const [includeSessionDetail, setIncludeSessionDetail] = useState(false);
  const { exportUsage, isLoading, error } = useUsageAnalyticsExport();

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Download usage analytics — {clientName}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack align="stretch" spacing={4}>
            <HStack>
              <FormControl>
                <FormLabel>From</FormLabel>
                <Input
                  type="date"
                  value={from}
                  onChange={(e) => setFrom(e.target.value)}
                />
              </FormControl>
              <FormControl>
                <FormLabel>To</FormLabel>
                <Input
                  type="date"
                  value={to}
                  onChange={(e) => setTo(e.target.value)}
                />
              </FormControl>
            </HStack>
            <FormControl display="flex" alignItems="center">
              <FormLabel mb={0}>Include per-session detail</FormLabel>
              <Switch
                isChecked={includeSessionDetail}
                onChange={(e) => setIncludeSessionDetail(e.target.checked)}
              />
            </FormControl>
            {error && (
              <Text color="red.500" fontSize="sm">
                {error}
              </Text>
            )}
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="green"
            isLoading={isLoading}
            onClick={() =>
              exportUsage({
                clientNames: [clientName],
                from,
                to,
                includeSessionDetail,
              })
            }
          >
            Generate
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
